import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'

export const contactListingAgent = variables =>
  fetch.forAuctionGraph({
    query: gql`
      mutation resiPdp_contactListingAgent($listingId: ID!, $message: String!) {
        contactListingAgent(input: { listingId: $listingId, message: $message })
      }
    `,
    variables,
  })
